import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'
const renderIcon = (color: string) => (
    <path
        d='M9 5L16 12L9 19'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
        fillRule='evenodd'
    />
)
export const ChevronRight: React.FC<IconProps> = ({ color, size }) => <IconWrapper {...{ size, color, renderIcon }} />
